//USERS
export const FETCH_USER_REQUEST = "fetchuser";
export const FETCH_USER_SUCCESS = "fetchsuccess";
export const FETCH_USER_FAILURE = "fetchfailure";
export const UPDATE_COMMUNICATIONS = "updatecommunications";
